'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherEye } from '@subframe/core';
import { selectCurrentEscritorio } from '@/features/escritorio/store/crud/selectors';
import { useAppSelector } from '@/store/hooks';
export const GuestWorkspaceBanner: React.FC = () => {
  const $ = _c(3);
  const current = useAppSelector(selectCurrentEscritorio);
  if (!current?.guestAccess) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FeatherEye className="text-warning-700 h-4 w-4 shrink-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== current.nomeFantasia) {
    t1 = <div className="bg-warning-50 border-warning-200 flex w-full items-center gap-2 border-b border-solid px-4 py-2">{t0}<span className="text-caption font-caption text-warning-700">Você está acessando <strong>{current.nomeFantasia}</strong> como convidado. Apenas as notificações compartilhadas com você ficam visíveis.</span></div>;
    $[1] = current.nomeFantasia;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};